import gql from 'graphql-tag'
import BOOKED_APPOINTMENT_QUERY from './bookedAppointmentQuery'

export default gql`
mutation bookAppointment(
  $date: DateTime!
  $duration: Int!
  $serviceId: ID!
  $staffId: ID
  $answers: Json
  $customerId: ID
  $customerName: String
  $customerEmail: String
  $customerPhone: String
  $clientTimezone: String
  $location: String
  $paymentProvider: String
  $paymentId: String
  $transactionUrl: String
  $requestUrl: String
  $guests: [CreateGuestInput!]
  $isCustomTime: Boolean
  $requestTimeMessage: String
  $couponCode: String
) {
  bookAppointment(
    date: $date
    serviceId: $serviceId
    duration: $duration
    staffId: $staffId
    answers: $answers
    clientTimezone: $clientTimezone
    customerId: $customerId
    customerName: $customerName
    customerEmail: $customerEmail
    customerPhone: $customerPhone
    location: $location
    paymentProvider: $paymentProvider
    paymentId: $paymentId
    transactionUrl: $transactionUrl
    requestUrl: $requestUrl
    guests: $guests
    isCustomTime: $isCustomTime
    requestTimeMessage: $requestTimeMessage
    couponCode: $couponCode
  ) {
    ${BOOKED_APPOINTMENT_QUERY}
  }
}
`
